<template>
	<div class="job-evaluation-level">
		<div>
			<div class='tw-mb-4'>
				<label>Rol</label>
				<v-select
					solo
					class="custom-select"
					item-text="name"
					item-value="id"
					:items="levelInfo.role.data"
					v-model="jobCopied.role"
					@change="onSelectChange"
				></v-select>
			</div>
			<div class='tw-mb-4'>
				<label>Titulación Elegible</label>
				<v-select
					solo
					class="custom-select"
					item-text="name"
					item-value="id"
					:items="levelInfo.title.data"
					v-model="jobCopied.title"
					@change="onSelectChange"
				></v-select>
			</div>
			<div class='tw-mb-4'>
				<label>Exp. Profesional Elegible</label>
				<v-select
					solo
					class="custom-select"
					item-text="name"
					item-value="id"
					:items="levelInfo.experience.data"
					v-model="jobCopied.experience"
					@change="onSelectChange"
				></v-select>
			</div>
			<div class='tw-mb-4'>
				<label>Nivel de Inglés</label>
				<v-select
					solo
					class="custom-select"
					item-text="name"
					item-value="id"
					:items="levelInfo.englishLevel.data"
					v-model="jobCopied.englishLevel"
					@change="onSelectChange"
				></v-select>
			</div>
			<div class='tw-mb-4'>
				<label>Área al que pertenece el puesto</label>
				<v-select
					solo
					class="custom-select"
					item-text="name"
					item-value="id"
					:items="groups"
					v-model="jobCopied.areaId"
					@change="onSelectChange"
				></v-select>
			</div>
			<div class='tw-mb-4'>
				<label>Cantidad de puestos</label>
				<v-text-field
					solo
					class="input-text"
					type="number"
					v-model="jobCopied.quantityPerson"
					@input="onSelectChange"
				></v-text-field>
			</div>
			<div class='tw-mb-4' v-if="jobCopied.typeVerb">
				<v-checkbox
					v-if="jobCopied.typeVerb === 'HIGH'"
					v-model="jobCopied.isHighestAuthority"
					label="Máxima Autoridad de la empresa"
					@change="onHighestAuthorityChange"
					:disabled="hasOtherHighestAuthority || jobCopied.isAreaManager"
					hide-details
					color="success"
					class="custom-checkbox"
				></v-checkbox>
				<v-checkbox
					v-model="jobCopied.isAreaManager"
					label="Responsable de Área"
					@change="onAreaManagerChange"
					:disabled="hasOtherAreaManager || jobCopied.isHighestAuthority"
					hide-details
					color="success"
					class="custom-checkbox"
				></v-checkbox>
			</div>
		</div>
	</div>
</template>

<script>
import { clone, pathOr, any, propEq, both } from 'ramda';
import { mapState } from 'vuex';

export default {
	name: 'guideline-job-level-selector',
	props: {
		levelInfo: {
			default: () => ({}),
		},
		selectedJob: {
			default: () => ({}),
		},
	},
	watch: {
		selectedJob: {
			deep: true,
			immediate: true,
			handler(val) {
				if (val && Object.keys(val).length > 0) {
					this.jobCopied = clone(val);
				}
			},
		},
	},
	data() {
		return {
			jobCopied: {
				role: {},
				title: {},
				experience: {},
				areaId: {},
				isAreaManager: false,
				isHighestAuthority: false,
			},
		};
	},
	computed: {
		...mapState('jobEvaluation', {
			groups: state => state.supplies.guidelineModel.groups || [],
			jobList: pathOr([], ['supplies', 'guidelineModel', 'userForm', 'jobList']),
		}),
		hasOtherHighestAuthority() {
			return any(
				both(
					propEq('isHighestAuthority', true),
					job => job.id !== this.selectedJob.id,
				),
				this.jobList,
			);
		},
		hasOtherAreaManager() {
			const currentAreaId = this.jobCopied.areaId;
			if (!currentAreaId) return false;
			return any(
				both(
					propEq('isAreaManager', true),
					both(
						propEq('areaId', currentAreaId),
						job => job.id !== this.selectedJob.id,
					),
				),
				this.jobList,
			);
		},
	},
	methods: {
		onHighestAuthorityChange(val) {
			if (val) this.jobCopied.isAreaManager = false;
			this.onSelectChange();
		},
		onAreaManagerChange(val) {
			if (val) this.jobCopied.isHighestAuthority = false;
			this.onSelectChange();
		},
		onSelectChange() {
			this.$emit('selectedJobDataChanged', clone(this.jobCopied));
		},
	},
};
</script>

<style lang="scss" scoped>
.job-evaluation-level {
	border-top: solid 1px var(--app-color-gray);
	padding: 20px 40px;
	label {
		color: var(--app-color-info);
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/components/supplies/guideline-model/jobs-manager/job-info-edition/guideline-job-level-selector.vue